<nz-modal nzVisible="true" nzTitle="The first Modal">
  <ng-container *nzModalContent>
    <p i18n>Content one</p>
    <p i18n>Content two</p>
    <p i18n>Content three</p>
  </ng-container>
</nz-modal>
